<div class="container">


  <div *ngIf="showPopupInfoInsideTable">
    <p-dialog header="{{ 'campaign.info_actions' | translate }}" [(visible)]="showPopupInfoInsideTable">
      <app-info-action-3 [acmNoBurned]="acmNoBurned" (closeInfoPopup)="onClosePopupInfo()" [action]="singleAction"></app-info-action-3>
  </p-dialog>

  </div>

  <table #actiontable data-testid="actiontable" class="detail-tab actiontable" *ngIf="showTable">
    <thead>
      <tr>
        <th class="pl-4" colspan="2">{{ 'campaign.action_name' | translate }}</th>
        <th>{{ 'campaign.start_emission_date' | translate }}</th>
        <th>{{ 'campaign.end_fruition_date' | translate }}</th>
        <th style="text-align: center;">{{ 'campaign.campaign_name' | translate }}</th>
        <th style="text-align: center;">{{ 'campaign.action_type' | translate }}</th>
        <th style="text-align: center;">{{ 'campaign.actual_generated_coupon' | translate }}</th>
        <th style="text-align: center;">{{ 'campaign.code' | translate }}</th>
        <th style="text-align: center;">{{ 'campaign.status' | translate }}</th>
        <th></th>
      </tr>
    </thead>

    <tbody>

      <tr *ngFor="let action of actionData.data; let i=index;">
        <td class="pl-4" colspan="2" [ngClass]="checkExpiredCampaign()">{{ action.name }}</td>
        <td [ngClass]="checkExpiredCampaign()"> {{ action.start_emission_date |
          date:srvCalendar.pcalendarTranslate.dateFormatFilter }}</td>
        <td [ngClass]="checkExpiredCampaign()"> {{ action.end_emission_date|
          date:srvCalendar.pcalendarTranslate.dateFormatFilter }}</td>
          <td style="text-align: center;" [ngClass]="checkExpiredCampaign()">{{
            action.campaign_name }}</td>
        <td style="text-align: center;" [ngClass]="checkExpiredCampaign()">{{
          onGetActionDescription(action.action_type_id) }}</td>
        <td style="text-align: center;" [ngClass]="checkExpiredCampaign()">{{ action.actual_generated_coupon}}
        </td>
        <td style="text-align: center;" [ngClass]="checkExpiredCampaign()">{{ action.code }}</td>
        <td>
          <div class="status-btn-container">
            <button class="status-button " [style.background-color]="action.color" [style.pointer-events]="none">
              {{action.status}}
            </button>
          </div>
        </td>
        <td>
          <div class="detail-btn-container">
            <button class="btn-details">
              <i class="pi pi-eye" (click)="onOpenInfoAction(action.id)" style="margin-top:1px"></i>
            </button>
            <div class="d-flex flex-row">
              <button data-testid-generic="action-details" [attr.data-testid]="'action-details' + action.id" class="btn-details" (click)="toggleMenu(action.id,i)">
                <i class="pi pi-ellipsis-h margin-fit"></i>
              </button>
              <div class="dropdown-menu" *ngIf="action.menuActivated == true">
                <button class="dropdown-item-creation" data-testid-generic="action-edit" [attr.data-testid]="'action-edit' + action.id" (click)="editAction(action)">{{checkOnlyRead(action)}}</button>
                <button class="dropdown-item-creation" data-testid-generic="action-show" [attr.data-testid]="'action-show' + action.id" (click)="showCoupons(action.id)">{{
                  'campaign.actual_generated_coupon' | translate }}</button>
                <button class="dropdown-item-creation" data-testid-generic="action-delete" [attr.data-testid]="'action-delete' + action.id" (click)="onDeleteAction(action, i)"
                  [disabled]="action.status == 'Pubblicata'"
                  [ngClass]="{'disabled-button': action.status == 'Pubblicata'}">
                  {{ 'campaign.delete_action' | translate }}
                </button>
              </div>
            </div>
          </div>
        </td>
      </tr>

    </tbody>
  </table>
<div class="create-btn-container">
  <div class="opener-btn-container">
    <button data-testid="createNewAction" (click)="toggleMenuCreation()"
      [ngClass]="{'disabled-button': onCheckEndCampaign()}" [disabled]="onCheckEndCampaign()" class="new-action-button">
      <i class="pi pi-plus"></i>{{ 'campaign.create_new_action' | translate }}
    </button>

    <button (click)="onRefreshTable()" class="new-action-button" [ngClass]="{'disabled-button': onCheckEndCampaign()}"
      [disabled]="onCheckEndCampaign()">
      {{ 'campaign.refresh_action_list' | translate }}
    </button>

  </div>
  <div>
    <div class="hidden-menu-creation" *ngIf="menuCreationActive == true">
      <button data-testid="createNewCouponAction" class="dropdown-item-creation" (click)="onCreateNewAction()">
        {{ 'campaign.create_new_coupon' | translate }}
      </button>
      <button data-testid="createNewMessageAction" class="dropdown-item-creation" (click)="onCreateNewMessage()">
        {{ 'campaign.create_new_message' | translate }}
      </button>
    </div>
  </div>
</div>

<p-dialog header="{{ 'campaign.confirm_delete' | translate }}" [(visible)]="displayDeleteDialog" [modal]="true" [closable]="false"
      class="custom-dialog">

      <div>
        {{ 'campaign.confirm_delete_action' | translate }} {{ actionToDelete?.description }}??
      </div>

      <div class="custom-footer">
        <button type="button" pButton label="{{ 'common.cancel' | translate }}" (click)="closePopupDelete()" icon="pi pi-times"></button>
        <button type="button" pButton label="{{ 'common.confirm' | translate }}" (click)="onDefinitiveDelete(actionToDelete)" icon="pi pi-check"
          style="margin-left: .25em"></button>
      </div>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/action-table3/action-table3.component.html